import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'aca_portal';
  // app.component.ts (ngOnInit)
  ngOnInit() {
    const observer = new MutationObserver(() => {

      const links = document.querySelectorAll('a[href^="https://www.syncfusion.com"]');
      links.forEach(link => {
        // climb up until the top-most parent <div>
        let parentDiv: HTMLElement | null = link.closest('div');
        while (parentDiv && parentDiv.parentElement?.tagName === 'DIV') {
          parentDiv = parentDiv.parentElement as HTMLElement;
        }

        if (parentDiv) {
          console.log('Removing Syncfusion popup:');
          parentDiv.remove();
        }
      });

    });

    observer.observe(document.body, { childList: true, subtree: true });
  }



}